
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'audit-log-field-types-displaying-values-array-value',
    props: {
        value: {
            type: Array,
            required: true
        }
    }
})
